import axios from "axios";
import { url } from "../../../config";

export const FileDownloadCommentView = ({
  urlData,
  viewShow = false,
  onBtnClick = () => {},
}) => {
  if (!urlData) return null;

  const getFileName = (urlData) => {
    return urlData.substring(url.lastIndexOf("/") + 1);
  };

  const fileName = getFileName(urlData);

  const handleDownload = async () => {
    try {
      const response = await axios.get(urlData, {
        responseType: "blob",
      });

      const file = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const fileUrl = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName || "downloaded_file");
      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error("Download failed", error);
      alert("Failed to download file");
    }
  };

  return (
    <>
      <div className="rounded-xl border p-4 shadow-md w-full max-w-[30rem] flex justify-between items-center gap-2 bg-primary text-white">
        <div className="text-sm font-medium truncate">{fileName}</div>
        <div className="flex items-center gap-1">
          <button
            onClick={handleDownload}
            className="inline-block bg-lightBg text-primary text-sm px-4 py-2 rounded hover:bg-blue-700 hover:text-white"
          >
            Download
          </button>
          {viewShow && (
            <button
              onClick={onBtnClick}
              type="button"
              className="inline-block bg-lightBg text-primary text-sm px-4 py-2 rounded hover:bg-blue-700 hover:text-white"
            >
              view
            </button>
          )}
        </div>
      </div>
    </>
  );
};
